import React from "react";
import styles from "./PageLayout.module.scss";

const PageLayout = ({ children }) => {
  return (
    <div className={styles.pageLayoutContainer}>
      <div className={styles.childContainer}>{children}</div>
    </div>
  );
};

export default PageLayout;
